import React from 'react';

const ShelfManagement = () => {
  return (
    <div className="shelf-management">
      <div className="page-header">
        <h2>Raf Yönetimi</h2>
        <p>Raf yerlerini yönetin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default ShelfManagement; 